

import React from 'react';



import SidebarOrganizationTab from './SidebarOrganiTab';


const FullPageOrgChart: React.FC = () => {
  return (

    <SidebarOrganizationTab />
  );
};

export default FullPageOrgChart;
